import clsx from 'clsx';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@seeqdev/qomponents';
import type { AutoUpdateTimeScheduleEntry } from '@/schedule/schedule.types';

interface AutoUpdateTimeSchedulePropertiesProps {
  isInvalid: boolean;
  showRemoveIcon: boolean;
  entry: AutoUpdateTimeScheduleEntry;
  onChange: (updateTime: AutoUpdateTimeScheduleEntry) => void;
  onClickRemove: () => void;
  disabled?: boolean;
}

export const AutoUpdateTimeScheduleProperties = ({
  entry,
  onChange,
  isInvalid,
  showRemoveIcon,
  onClickRemove,
  disabled = false,
}: AutoUpdateTimeSchedulePropertiesProps) => {
  const { t } = useTranslation();
  const validationMessageId = useId();

  const onChangeTime = (newTime: string) => {
    if (newTime) {
      return onChange({ ...entry, time: newTime });
    }
  };

  return (
    <div className="flexColumnContainer tw:mb-sq-15 tw:w-sq-150!" data-testid="time-schedule-entry">
      <input
        type="time"
        data-testid="time-schedule-entry__time"
        className={clsx('noValidationIcons form-control tw:mr-sq-5 tw:w-sq-135!', isInvalid ? 'is-invalid' : '')}
        aria-invalid={isInvalid || undefined}
        aria-describedby={isInvalid ? validationMessageId : undefined}
        value={entry.time}
        onChange={(e) => onChangeTime(e.target.value)}
        required={true}
        disabled={disabled}
      />
      {isInvalid ? (
        <span id={validationMessageId} className="sr-only">
          {t('SCHEDULE_TYPE.INVALID_TIME')}
        </span>
      ) : null}

      {showRemoveIcon && !disabled ? (
        <Icon
          testId="time-schedule-entry__remove"
          extraClassNames="reportAutoUpdateTimeStrategy cursorPointer"
          onClick={onClickRemove}
          icon="fa-sharp fa-regular fa-close removeButton ng-scope sq-fairly-dark-gray"
          large={true}
        />
      ) : null}
    </div>
  );
};
